module.exports = __webpack_public_path__ + "img/6rm1.42c2c779.jpg";